const BOM = '﻿';
// const BOM = 'K';
export default BOM;
export const BOM_REG_EXP = new RegExp(BOM, 'g');
